export const translations = {
  tr: {
      nav: {
      home: 'Anasayfa',
      quote: 'Teklif Talebi',
      services: 'Hizmetler',
      about: 'Hakkımızda',
      contact: 'İletişim',
      getQuote: 'Teklif Al'
    },
    home: {
      heroTag: 'SLA · SLS · FDM 3D BASKI HİZMETLERİ',
      heroTitle: 'Fikrinizi',
      heroTitleAccent: 'Gerçeğe',
      heroTitleEnd: 'Dönüştürün',
      heroSubtitle: 'Endüstriyel kalitede SLA, SLS ve FDM 3D baskı hizmetleri. Tasarımınızı yükleyin, size özel teklifimizi 24 saat içinde gönderelim.',
      ctaPrimary: 'Teklif Talep Et',
      ctaSecondary: 'Hizmetleri İncele',
      statsParts: 'Üretilen Parça',
      statsDelivery: 'Ortalama Teslimat',
      statsAccuracy: 'Boyutsal Hassasiyet',
      statsSupport: 'Teknik Destek',
      howTitle: 'Nasıl Çalışır?',
      howSubtitle: 'Üç adımda fikriniz parça olsun',
      step1Title: 'Dosyayı Yükle',
      step1Desc: 'STL, OBJ, STEP veya 3MF formatında 3D modelinizi yükleyin.',
      step2Title: 'Teklif Talep Edin',
      step2Desc: 'Teknoloji, malzeme ve adet seçin. Ekibimiz size özel teklifimizi 24 saat içinde gönderir.',
      step3Title: 'Teslim Alın',
      step3Desc: 'Üretim başlasın. Hassasiyetle baskı alıp adresinize gönderelim.',
      techTitle: 'Teknolojilerimiz',
      techSubtitle: 'İhtiyacınıza uygun en doğru yöntem',
      slaTitle: 'SLA Baskı',
      slaDesc: 'UV reçine ile yüksek detaylı, pürüzsüz yüzeyli baskılar. Mücevher, dental ve modelleme için mükemmel.',
      slsTitle: 'SLS Baskı',
      slsDesc: 'Lazerle sinterlenmiş naylon tozdan dayanıklı, destek gerektirmeyen fonksiyonel parçalar. Endüstriyel uygulamalar için ideal.',
      fdmTitle: 'FDM Baskı',
      fdmDesc: 'Termoplastik filamentlerle dayanıklı, fonksiyonel parçalar. Prototipleme ve son kullanım için ideal.',
      learnMore: 'Detaylı İncele',
      materialsTitle: 'Malzemeler',
      materialsSubtitle: 'FDM ve SLA için zengin malzeme yelpazesi',
      ctaTitle: 'Projeniz için hazır mısınız?',
      ctaDesc: 'Dosyanızı yükleyin, 24 saat içinde size özel teklifimizi alın.',
      ctaButton: 'Teklif Talep Et',
      trustTitle: 'Üretim gücümüz',
      trustOnTime: 'Zamanında Teslim',
      trustDefect: 'Hata Oranı',
      trustMachines: 'Aktif Makine',
      trustIso: 'ISO 9001 Kalite Standardı',
      trustConfidential: 'Tüm yüklemeler güvenli ve gizlidir',
      galleryTitle: 'Vaka Galerisi',
      gallerySubtitle: 'Müşterilerimize teslim ettiğimiz parçalardan örnekler',
      brandsTitle: 'Bize güvenen markalar',
      testimonialsTitle: 'Müşterilerimiz Ne Diyor?',
      testimonialsSubtitle: 'Onları memnun etmek bizim önceliğimiz',
      testimonials: [
        {
          name: 'Mehmet Yılmaz',
          title: 'Ar-Ge Mühendisi',
          company: 'TekTaş Endüstri',
          text: 'Prototip parçalarımızı 3 günde elimize aldık. SLA hassasiyeti beklentimizin çok üzerindeydi. Artık tüm prototiplerimizi ROLVIA üzerinden yaptırıyoruz.',
          rating: 5
        },
        {
          name: 'Selin Demir',
          title: 'Endüstriyel Tasarımcı',
          company: 'Demir Design Studio',
          text: 'Anlık fiyat teklifi özelliği müşterilerimle iletişimde inanılmaz hız kazandırdı. SLS naylon parçaların dayanıklılığı şahane.',
          rating: 5
        },
        {
          name: 'Dr. Ahmet Kaya',
          title: 'Diş Hekimi',
          company: 'Kaya Dental Klinik',
          text: 'Dental modeller için tercih ettiğimiz çözüm. Yüzey kalitesi ve boyutsal hassasiyet rakipsiz. Teslim süresi her zaman söz verildiği gibi.',
          rating: 5
        },
        {
          name: 'Burak Aydın',
          title: 'Kurucu',
          company: 'RoboTech Robotik',
          text: 'Robotlarımızın şase ve dişli parçaları için SLS üretimi kullanıyoruz. Fonksiyonel testlerde sıfır arıza. Mühendis ekibi tasarım önerileriyle de destek oluyor.',
          rating: 5
        }
      ],
      brands: ['TekTaş Endüstri', 'Demir Design', 'Kaya Dental', 'RoboTech', 'Akın Otomotiv', 'ArkeMakina', 'ProtoLab', 'Mimari Stüdyo']
    },
    quote: {
      title: 'Teklif Talebi',
      subtitle: 'Dosyanızı yükleyin ve parametreleri seçin. Mühendis ekibimiz tasarımınızı inceleyip size özel teklifi 24 saat içinde gönderir.',
      uploadTitle: '1. 3D Modelinizi Yükleyin',
      uploadHint: 'STL, OBJ, STEP, 3MF — Max 100MB',
      dropHere: 'Dosyayı buraya bırakın veya tıklayın',
      orBrowse: 'cihazınızdan seçin',
      fileSelected: 'Seçilen dosya',
      remove: 'Kaldır',
      configTitle: '2. Üretim Parametreleri',
      technology: 'Teknoloji',
      material: 'Malzeme',
      color: 'Renk',
      quality: 'Kalite (Katman)',
      infill: 'Dolgu Oranı',
      quantity: 'Adet',
      finish: 'Yüzey İşlemi',
      summaryTitle: 'Talep Özeti',
      leadTime: 'Tahmini Teslim',
      days: 'iş günü',
      noFile: 'Talep özetini görmek için lütfen dosya yükleyin',
      placeOrder: 'Teklif İste',
      contactInfo: 'İletişim Bilgileri',
      fullName: 'Ad Soyad',
      email: 'E-posta',
      phone: 'Telefon',
      notes: 'Notlar (opsiyonel)',
      orderSuccess: 'Talebiniz alındı! 24 saat içinde size özel teklif göndereceğiz. Talep No:',
      orderError: 'Bir hata oluştu, lütfen tekrar deneyin.',
      none: 'Yok',
      standard: 'Standart',
      polishing: 'Cilalama',
      painting: 'Boyama',
      supportRemoval: 'Destek Temizliği',
      manualNote: 'Fiyat, tasarımınız ve adet uzmanlarımız tarafından incelendikten sonra size e-posta ile iletilir.'
    },
    services: {
      title: 'Hizmetlerimiz',
      subtitle: 'SLA, SLS ve FDM odaklı, uçtan uca 3D baskı çözümleri',
      slaHeading: 'SLA (Stereolithography)',
      slaLong: 'SLA, sıvı UV reçinenin lazer ya da LCD ışıkla katmanlar halinde sertleştirilmesi prensibine dayanır. Yüksek detay, pürüzsüz yüzey ve karmaşık geometri gerektiren parçalar için idealdir.',
      slaFeatures: [
        'Mikron seviyesinde detay',
        'Standart, Tough, Clear, Dental, Castable reçineler',
        'Katman kalınlığı: 0.025 — 0.10 mm',
        '±0.1 mm boyutsal tolerans'
      ],
      slsHeading: 'SLS (Selective Laser Sintering)',
      slsLong: 'SLS, ince naylon tozun lazerle katman katman sinterlenmesi yöntemidir. Destek yapısı gerektirmediği için karmaşık iç geometrili, fonksiyonel ve dayanıklı parça üretimi için en güçlü teknolojilerden biridir.',
      slsFeatures: [
        'Destek yapısı gerektirmez',
        'PA12, PA11, PA12-GF (Cam Takviyeli), TPU',
        'Katman kalınlığı: 0.10 — 0.12 mm',
        '±0.3 mm boyutsal tolerans, yüksek dayanım'
      ],
      fdmHeading: 'FDM (Fused Deposition Modeling)',
      fdmLong: 'FDM, termoplastik bir filamentin eritilerek katman katman biriktirilmesi yöntemidir. Hızlı prototipleme, fonksiyonel parçalar ve büyük boyutlu üretimler için en verimli teknolojidir.',
      fdmFeatures: [
        'Yüksek dayanım & ısı direnci',
        'PLA, PETG, ABS, ASA, TPU, Naylon',
        'Katman kalınlığı: 0.10 — 0.30 mm',
        '±0.3 mm boyutsal tolerans'
      ],
      whyTitle: 'Neden ROLVIA DESIGN?',
      why1Title: 'Hızlı Üretim',
      why1Desc: 'Çoğu sipariş 2–5 iş günü içinde teslim edilir.',
      why2Title: 'Kalite Garantisi',
      why2Desc: 'Her parça üretim sonrası kontrol edilir.',
      why3Title: 'Şeffaf Fiyatlandırma',
      why3Desc: 'Detaylı talep formu ile tasarımınıza özel net fiyat.',
      why4Title: 'Uzman Destek',
      why4Desc: 'Tasarım optimizasyonu için mühendis desteği.',

      compareTitle: 'Teknoloji Karşılaştırması',
      compareSubtitle: 'Doğru teknolojiyi seçmeniz için yan yana karşılaştırma',
      compareCols: ['Özellik', 'SLA', 'SLS', 'FDM'],
      compareRows: [
        ['Malzeme Tipi', 'Sıvı UV Reçine', 'Naylon Tozu', 'Termoplastik Filament'],
        ['Min. Et Kalınlığı', '0.6 mm', '0.8 mm', '1.0 mm'],
        ['Boyutsal Tolerans', '±0.1 mm', '±0.3 mm', '±0.3 mm'],
        ['Katman Kalınlığı', '0.025 – 0.10 mm', '0.10 – 0.12 mm', '0.10 – 0.30 mm'],
        ['Destek Yapısı', 'Evet', 'Hayır', 'Evet'],
        ['Yüzey Kalitesi', 'Çok Yüksek', 'Mat / Pürüzlü', 'Görünür Katmanlar'],
        ['Karmaşık Geometri', 'Çok İyi', 'Mükemmel', 'Sınırlı'],
        ['İdeal Kullanım', 'Detay, Dental, Mücevher', 'Fonksiyonel, Seri Üretim', 'Prototip, Büyük Parça']
      ],

      finishTitle: 'Yüzey İşlemleri',
      finishSubtitle: 'Parçalarınızı bir adım öteye taşıyın',
      finishes: [
        { t: 'Zımparalama', d: 'Katman çizgilerini gidererek pürüzsüz yüzey elde ederiz.' },
        { t: 'Cilalama', d: 'Yüksek parlaklık veren mekanik veya kimyasal cilalama.' },
        { t: 'Boyama', d: 'Pantone kataloğundan istediğiniz renkte boyama.' },
        { t: 'Diş Açma', d: 'Vida ve cıvatalar için iç diş açma & insert montajı.' },
        { t: 'Destek Temizliği', d: 'Destek yapılarının özenli temizliği ve son rötuş.' },
        { t: 'Tampograf Baskı', d: 'Logo veya seri numarası gibi baskı uygulamaları.' }
      ],

      industriesTitle: 'Sektörler & Uygulamalar',
      industriesSubtitle: 'Farklı sektörlerde yüzlerce projede yer aldık',
      industries: [
        { t: 'Otomotiv', d: 'Prototip, fikstür, iç trim parçaları' },
        { t: 'Endüstriyel Tasarım', d: 'Form modelleri, sunum prototipleri' },
        { t: 'Dental', d: 'Modeller, splint ve cerrahi rehberler' },
        { t: 'Mücevher', d: 'Castable döküm modelleri' },
        { t: 'Mimarlık', d: 'Maket ve detay parçaları' },
        { t: 'Eğitim', d: 'Eğitim modelleri ve maker projeleri' },
        { t: 'Tıbbi', d: 'Anatomik modeller, özel cihaz parçaları' },
        { t: 'Robotik', d: 'Şase, dişli ve fonksiyonel parçalar' }
      ],

      faqTitle: 'Sıkça Sorulan Sorular',
      faqSubtitle: 'Aklınıza takılanlar için kısa cevaplar',
      faqs: [
        { q: 'Hangi dosya formatlarını destekliyorsunuz?', a: 'STL, OBJ, STEP (.step/.stp) ve 3MF formatlarındaki 3D modelleri kabul ediyoruz. Maksimum dosya boyutu 100MB.' },
        { q: 'Minimum sipariş tutarı var mı?', a: 'Tasarımınız ve adetinize göre size özel fiyat veriyoruz. Çok küçük parçalarda minimum üretim ücreti uygulanabilir, bu detay teklifimizde net olarak belirtilir.' },
        { q: 'Teslim süreleri nedir?', a: 'Talep aldıktan sonra 24 saat içinde teklif gönderiyoruz. Onaylanan siparişler standartta 2–5 iş günü içinde üretilir; SLS siparişler için +2-3 gün, büyük adetlerde teslim süresi artabilir.' },
        { q: 'Tasarım hizmeti veriyor musunuz?', a: 'Evet, mühendis ekibimiz tasarım optimizasyonu ve gerekirse sıfırdan CAD modelleme desteği sağlamaktadır.' },
        { q: 'Hangi teknolojiyi seçmeliyim?', a: 'Yüksek detay/şeffaflık için SLA, dayanıklı fonksiyonel parça için SLS, hızlı ve uygun maliyetli prototip için FDM idealdir. Emin değilseniz iletişime geçin, yönlendirelim.' },
        { q: 'Toleranslarınız nedir?', a: 'SLA için ±0.1 mm, SLS ve FDM için ±0.3 mm tolerans değerlerinde çalışıyoruz.' },
        { q: 'Sipariş takibi nasıl yapılır?', a: 'Sipariş oluştuğunda size özel bir sipariş numarası (ROL-…) verilir. E-posta üzerinden tüm aşamalarda bilgilendirme yaparız.' },
        { q: 'Dosyalarımın gizliliği güvende mi?', a: 'Tüm yüklenen tasarım dosyaları gizli tutulur ve sadece üretim ekibimiz tarafından erişilebilir.' }
      ]
    },
    about: {
      title: 'Hakkımızda',
      subtitle: 'Türkiye’nin yeni nesil 3D üretim ortağı',
      p1: 'ROLVIA DESIGN, mühendislerin ve tasarımcıların fikirlerini somut parçalara dönüştürmek için kurulmuş bir 3D baskı stüdyosudur. FDM ve SLA teknolojilerinde derin uzmanlığa sahip ekibimiz, prototipten küçük seri üretime kadar geniş bir yelpazede hizmet sunar.',
      p2: 'Tasarımdan teslimata kadar tüm süreci tek elden yöneterek, müşterilerimize hız, kalite ve şeffaf fiyatlandırma garantisi veriyoruz. Endüstriyel tasarım, mimarlık, dental, mücevher ve hobi alanlarında yüzlerce projeye imza attık.',
      missionTitle: 'Misyonumuz',
      missionDesc: 'Üretimi demokratikleştirmek; her tasarımcının kolayca, hızlı ve uygun maliyetle üretim yapabilmesini sağlamak.',
      visionTitle: 'Vizyonumuz',
      visionDesc: 'Türkiye’nin en güvenilir ve teknolojik olarak öncü 3D baskı platformu olmak.',
      contactTitle: 'İletişime Geçin',
      contactSubtitle: 'Sorularınız için bize ulaşın',
      formName: 'Ad Soyad',
      formEmail: 'E-posta',
      formSubject: 'Konu',
      formMessage: 'Mesajınız',
      formSend: 'Gönder',
      formSuccess: 'Mesajınız alındı, en kısa sürede dönüş yapacağız.',
      formError: 'Bir hata oluştu, lütfen tekrar deneyin.',
      address: 'Adres',
      addressText: 'İkitelli OSB, İstanbul, Türkiye',
      phone: 'Telefon',
      email: 'E-posta',
      hours: 'Çalışma Saatleri',
      hoursText: 'Pzt – Cum: 09:00 – 18:00'
    },
    footer: {
      tagline: 'SLA, SLS ve FDM 3D baskı hizmetleri.',
      links: 'Hızlı Bağlantılar',
      contact: 'İletişim',
      rights: 'Tüm hakları saklıdır.'
    },
    auth: {
      login: 'Giriş Yap',
      loginGoogle: 'Google ile Giriş Yap',
      logout: 'Çıkış',
      dashboard: 'Panelim',
      myOrders: 'Taleplerim',
      profile: 'Profil',
      admin: 'Admin Panel',
      welcome: 'Hoş geldin'
    },
    dashboard: {
      title: 'Taleplerim',
      subtitle: 'Tüm teklif taleplerinizi buradan takip edebilirsiniz',
      empty: 'Henüz bir talebiniz yok.',
      newQuote: 'Yeni Teklif Talep Et',
      orderNumber: 'Talep No',
      date: 'Tarih',
      tech: 'Teknoloji',
      material: 'Malzeme',
      qty: 'Adet',
      status: 'Durum',
      price: 'Teklif',
      pending: 'Fiyat bekleniyor',
      view: 'Detay',
      backToList: 'Geri',
      orderDetail: 'Talep Detayı',
      productionParams: 'Üretim Parametreleri',
      contactInfo: 'İletişim',
      file: 'Yüklenen Dosya',
      download: 'İndir',
      messages: 'Mesajlar',
      noMessages: 'Henüz mesaj yok. Aşağıdan bizimle iletişime geçebilirsiniz.',
      sendMessage: 'Mesaj Gönder',
      typeMessage: 'Mesajınızı yazın…',
      you: 'Siz',
      team: 'ROLVIA Ekibi',
      statuses: {
        quote_requested: 'Teklif Bekliyor',
        quoted: 'Teklif Verildi',
        approved: 'Onaylandı',
        in_production: 'Üretimde',
        shipped: 'Kargoda',
        completed: 'Tamamlandı',
        cancelled: 'İptal Edildi'
      },
      profileTitle: 'Profil Bilgilerim',
      profileSubtitle: 'İletişim bilgilerinizi güncel tutun',
      fullName: 'Ad Soyad',
      email: 'E-posta',
      phone: 'Telefon',
      address: 'Adres',
      save: 'Kaydet',
      saved: 'Profil güncellendi',
      saveError: 'Bir hata oluştu'
    },
    admin: {
      title: 'Admin Panel',
      subtitle: 'Tüm teklif taleplerini yönetin',
      tabs: { orders: 'Talepler', users: 'Kullanıcılar' },
      filterAll: 'Tümü',
      noOrders: 'Talep yok',
      customer: 'Müşteri',
      setQuote: 'Fiyat & Durum',
      quotedPrice: 'Teklif Fiyatı (₺)',
      newStatus: 'Yeni Durum',
      update: 'Güncelle',
      reply: 'Yanıt yaz…',
      send: 'Gönder'
    }
  },
  en: {
    nav: {
      home: 'Home',
      quote: 'Quote Request',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      getQuote: 'Get Quote'
    },
    home: {
      heroTag: 'SLA · SLS · FDM 3D PRINTING SERVICES',
      heroTitle: 'Turn Your',
      heroTitleAccent: 'Ideas',
      heroTitleEnd: 'Into Reality',
      heroSubtitle: 'Industrial-grade SLA, SLS and FDM 3D printing services. Upload your design and we will send you a tailored quote within 24 hours.',
      ctaPrimary: 'Request a Quote',
      ctaSecondary: 'Explore Services',
      statsParts: 'Parts Produced',
      statsDelivery: 'Average Lead Time',
      statsAccuracy: 'Dimensional Accuracy',
      statsSupport: 'Technical Support',
      howTitle: 'How It Works',
      howSubtitle: 'Three steps from idea to part',
      step1Title: 'Upload File',
      step1Desc: 'Upload your 3D model in STL, OBJ, STEP or 3MF format.',
      step2Title: 'Request a Quote',
      step2Desc: 'Pick technology, material and quantity. Our team reviews your design and sends a tailored quote within 24 hours.',
      step3Title: 'Receive Parts',
      step3Desc: 'We print with precision and deliver to your address.',
      techTitle: 'Our Technologies',
      techSubtitle: 'The right method for your need',
      slaTitle: 'SLA Printing',
      slaDesc: 'High-detail, smooth-surface prints with UV resin. Perfect for jewelry, dental and modeling.',
      slsTitle: 'SLS Printing',
      slsDesc: 'Durable functional parts from laser-sintered nylon powder with no support structures. Ideal for industrial applications.',
      fdmTitle: 'FDM Printing',
      fdmDesc: 'Durable functional parts with thermoplastic filaments. Ideal for prototyping and end-use parts.',
      learnMore: 'Learn More',
      materialsTitle: 'Materials',
      materialsSubtitle: 'Rich material library for FDM and SLA',
      ctaTitle: 'Ready for your project?',
      ctaDesc: 'Upload your file and get a tailored quote in minutes.',
      ctaButton: 'Get a Quote',
      trustTitle: 'Our production strength',
      trustOnTime: 'On-Time Delivery',
      trustDefect: 'Defect Rate',
      trustMachines: 'Active Machines',
      trustIso: 'ISO 9001 Quality Standard',
      trustConfidential: 'All uploads are secure and confidential',
      galleryTitle: 'Case Gallery',
      gallerySubtitle: 'Examples of parts delivered to our customers',
      brandsTitle: 'Trusted by',
      testimonialsTitle: 'What Our Customers Say',
      testimonialsSubtitle: 'Their satisfaction is our priority',
      testimonials: [
        {
          name: 'Mehmet Yılmaz',
          title: 'R&D Engineer',
          company: 'TekTaş Industries',
          text: 'We received our prototype parts in 3 days. SLA precision exceeded our expectations. We now do all prototypes through ROLVIA.',
          rating: 5
        },
        {
          name: 'Selin Demir',
          title: 'Industrial Designer',
          company: 'Demir Design Studio',
          text: 'The instant quote feature dramatically sped up communication with my clients. SLS nylon parts are incredibly durable.',
          rating: 5
        },
        {
          name: 'Dr. Ahmet Kaya',
          title: 'Dentist',
          company: 'Kaya Dental Clinic',
          text: 'Our go-to choice for dental models. Surface quality and dimensional accuracy are unmatched. Lead times are always as promised.',
          rating: 5
        },
        {
          name: 'Burak Aydın',
          title: 'Founder',
          company: 'RoboTech Robotics',
          text: 'We use SLS for our robot chassis and gear parts. Zero failure in functional tests. The engineering team also helps with design suggestions.',
          rating: 5
        }
      ],
      brands: ['TekTaş Industries', 'Demir Design', 'Kaya Dental', 'RoboTech', 'Akın Automotive', 'ArkeMachine', 'ProtoLab', 'Mimari Studio']
    },
    quote: {
      title: 'Quote Request',
      subtitle: 'Upload your file and pick parameters. Our engineers will review and send you a tailored quote within 24 hours.',
      uploadTitle: '1. Upload Your 3D Model',
      uploadHint: 'STL, OBJ, STEP, 3MF — Max 100MB',
      dropHere: 'Drop your file here or click',
      orBrowse: 'browse from device',
      fileSelected: 'Selected file',
      remove: 'Remove',
      configTitle: '2. Production Parameters',
      technology: 'Technology',
      material: 'Material',
      color: 'Color',
      quality: 'Quality (Layer)',
      infill: 'Infill',
      quantity: 'Quantity',
      finish: 'Surface Finish',
      summaryTitle: 'Request Summary',
      leadTime: 'Estimated Lead Time',
      days: 'business days',
      noFile: 'Upload a file to see your request summary',
      placeOrder: 'Request Quote',
      contactInfo: 'Contact Info',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      notes: 'Notes (optional)',
      orderSuccess: 'Request received! We will send your tailored quote within 24 hours. Request No:',
      orderError: 'Something went wrong, please try again.',
      none: 'None',
      standard: 'Standard',
      polishing: 'Polishing',
      painting: 'Painting',
      supportRemoval: 'Support Removal',
      manualNote: 'Pricing will be emailed after our specialists review your design and quantity.'
    },
    services: {
      title: 'Our Services',
      subtitle: 'End-to-end 3D printing focused on SLA, SLS and FDM',
      slaHeading: 'SLA (Stereolithography)',
      slaLong: 'SLA cures liquid UV resin layer by layer with laser or LCD light. Ideal for parts requiring high detail, smooth surface and complex geometry.',
      slaFeatures: [
        'Micron-level detail',
        'Standard, Tough, Clear, Dental, Castable resins',
        'Layer thickness: 0.025 — 0.10 mm',
        '±0.1 mm dimensional tolerance'
      ],
      slsHeading: 'SLS (Selective Laser Sintering)',
      slsLong: 'SLS sinters fine nylon powder layer by layer with a laser. Because it requires no support structures, it is one of the strongest technologies for complex internal geometries and durable functional parts.',
      slsFeatures: [
        'No support structures required',
        'PA12, PA11, PA12-GF (Glass-Filled), TPU',
        'Layer thickness: 0.10 — 0.12 mm',
        '±0.3 mm tolerance, high strength'
      ],
      fdmHeading: 'FDM (Fused Deposition Modeling)',
      fdmLong: 'FDM melts a thermoplastic filament and deposits it layer by layer. The most efficient technology for rapid prototyping, functional parts and large-scale production.',
      fdmFeatures: [
        'High strength & heat resistance',
        'PLA, PETG, ABS, ASA, TPU, Nylon',
        'Layer thickness: 0.10 — 0.30 mm',
        '±0.3 mm dimensional tolerance'
      ],
      whyTitle: 'Why ROLVIA DESIGN?',
      why1Title: 'Fast Production',
      why1Desc: 'Most orders ship within 2–5 business days.',
      why2Title: 'Quality Guarantee',
      why2Desc: 'Every part is inspected post-production.',
      why3Title: 'Transparent Pricing',
      why3Desc: 'Detailed request form yields a clear, custom quote.',
      why4Title: 'Expert Support',
      why4Desc: 'Engineering support for design optimization.',

      compareTitle: 'Technology Comparison',
      compareSubtitle: 'Side-by-side comparison to pick the right process',
      compareCols: ['Property', 'SLA', 'SLS', 'FDM'],
      compareRows: [
        ['Material Type', 'Liquid UV Resin', 'Nylon Powder', 'Thermoplastic Filament'],
        ['Min Wall Thickness', '0.6 mm', '0.8 mm', '1.0 mm'],
        ['Dimensional Tolerance', '±0.1 mm', '±0.3 mm', '±0.3 mm'],
        ['Layer Thickness', '0.025 – 0.10 mm', '0.10 – 0.12 mm', '0.10 – 0.30 mm'],
        ['Support Structures', 'Yes', 'No', 'Yes'],
        ['Surface Finish', 'Very High', 'Matte / Grainy', 'Visible Layers'],
        ['Complex Geometry', 'Very Good', 'Excellent', 'Limited'],
        ['Ideal For', 'Detail, Dental, Jewelry', 'Functional, Batch', 'Prototype, Large Parts']
      ],

      finishTitle: 'Surface Finishing',
      finishSubtitle: 'Take your parts one step further',
      finishes: [
        { t: 'Sanding', d: 'Smooth surface by removing layer lines and minor defects.' },
        { t: 'Polishing', d: 'High-gloss mechanical or chemical polishing.' },
        { t: 'Painting', d: 'Custom color painting from the Pantone catalog.' },
        { t: 'Threading', d: 'Internal threading & heat-set insert installation.' },
        { t: 'Support Removal', d: 'Careful removal of support structures and finishing.' },
        { t: 'Pad Printing', d: 'Pad printing applications such as logo or serial number.' }
      ],

      industriesTitle: 'Industries & Applications',
      industriesSubtitle: 'We have delivered projects across many industries',
      industries: [
        { t: 'Automotive', d: 'Prototypes, fixtures, interior trim parts' },
        { t: 'Industrial Design', d: 'Form models, presentation prototypes' },
        { t: 'Dental', d: 'Models, splints and surgical guides' },
        { t: 'Jewelry', d: 'Castable casting models' },
        { t: 'Architecture', d: 'Models and detail parts' },
        { t: 'Education', d: 'Educational models and maker projects' },
        { t: 'Medical', d: 'Anatomical models, custom device parts' },
        { t: 'Robotics', d: 'Chassis, gears and functional components' }
      ],

      faqTitle: 'Frequently Asked Questions',
      faqSubtitle: 'Quick answers to common questions',
      faqs: [
        { q: 'Which file formats are supported?', a: 'We accept STL, OBJ, STEP (.step/.stp) and 3MF 3D models. Max file size 100MB.' },
        { q: 'Is there a minimum order amount?', a: 'We provide custom pricing based on your design and quantity. A small minimum production fee may apply for very tiny parts, and this will be clearly stated in our quote.' },
        { q: 'What are the lead times?', a: 'We send quotes within 24 hours of receiving your request. Approved orders are typically produced in 2–5 business days; SLS adds +2-3 days, and large batches may take longer.' },
        { q: 'Do you offer design services?', a: 'Yes, our engineering team supports design optimization and CAD modeling from scratch if needed.' },
        { q: 'Which technology should I choose?', a: 'SLA is best for high detail/transparency, SLS for durable functional parts, FDM for fast, affordable prototypes. Contact us if unsure.' },
        { q: 'What are your tolerances?', a: 'SLA: ±0.1 mm. SLS and FDM: ±0.3 mm.' },
        { q: 'How do I track my order?', a: 'You receive a unique order number (ROL-…) and email updates at every stage.' },
        { q: 'Is my file confidential?', a: 'All uploaded designs are kept confidential and accessible only to our production team.' }
      ]
    },
    about: {
      title: 'About Us',
      subtitle: 'Turkey’s next-gen 3D production partner',
      p1: 'ROLVIA DESIGN is a 3D printing studio founded to turn the ideas of engineers and designers into tangible parts. With deep expertise in FDM and SLA, our team serves everything from prototyping to small-batch production.',
      p2: 'We manage the entire pipeline from design to delivery, ensuring speed, quality and transparent pricing. We have delivered hundreds of projects across industrial design, architecture, dental, jewelry and hobby markets.',
      missionTitle: 'Our Mission',
      missionDesc: 'Democratize manufacturing — empower every designer to produce easily, quickly and affordably.',
      visionTitle: 'Our Vision',
      visionDesc: 'To be Turkey’s most trusted and technologically leading 3D printing platform.',
      contactTitle: 'Get in Touch',
      contactSubtitle: 'Reach out for any questions',
      formName: 'Full Name',
      formEmail: 'Email',
      formSubject: 'Subject',
      formMessage: 'Your Message',
      formSend: 'Send',
      formSuccess: 'Your message was received, we will get back shortly.',
      formError: 'Something went wrong, please try again.',
      address: 'Address',
      addressText: 'Ikitelli OSB, Istanbul, Turkey',
      phone: 'Phone',
      email: 'Email',
      hours: 'Working Hours',
      hoursText: 'Mon – Fri: 09:00 – 18:00'
    },
    footer: {
      tagline: 'SLA, SLS and FDM 3D printing services.',
      links: 'Quick Links',
      contact: 'Contact',
      rights: 'All rights reserved.'
    },
    auth: {
      login: 'Sign In',
      loginGoogle: 'Sign in with Google',
      logout: 'Sign Out',
      dashboard: 'My Panel',
      myOrders: 'My Requests',
      profile: 'Profile',
      admin: 'Admin Panel',
      welcome: 'Welcome'
    },
    dashboard: {
      title: 'My Requests',
      subtitle: 'Track all your quote requests here',
      empty: 'No requests yet.',
      newQuote: 'New Quote Request',
      orderNumber: 'Request No',
      date: 'Date',
      tech: 'Technology',
      material: 'Material',
      qty: 'Qty',
      status: 'Status',
      price: 'Quote',
      pending: 'Pending price',
      view: 'Details',
      backToList: 'Back',
      orderDetail: 'Request Details',
      productionParams: 'Production Parameters',
      contactInfo: 'Contact',
      file: 'Uploaded File',
      download: 'Download',
      messages: 'Messages',
      noMessages: 'No messages yet. You can reach out below.',
      sendMessage: 'Send Message',
      typeMessage: 'Type your message…',
      you: 'You',
      team: 'ROLVIA Team',
      statuses: {
        quote_requested: 'Awaiting Quote',
        quoted: 'Quote Sent',
        approved: 'Approved',
        in_production: 'In Production',
        shipped: 'Shipped',
        completed: 'Completed',
        cancelled: 'Cancelled'
      },
      profileTitle: 'My Profile',
      profileSubtitle: 'Keep your contact info up to date',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      save: 'Save',
      saved: 'Profile updated',
      saveError: 'Something went wrong'
    },
    admin: {
      title: 'Admin Panel',
      subtitle: 'Manage all quote requests',
      tabs: { orders: 'Requests', users: 'Users' },
      filterAll: 'All',
      noOrders: 'No requests',
      customer: 'Customer',
      setQuote: 'Price & Status',
      quotedPrice: 'Quote Price (₺)',
      newStatus: 'New Status',
      update: 'Update',
      reply: 'Write reply…',
      send: 'Send'
    }
  }
};
